import { createContext } from 'react'

const DefaultSettingsSetupContext = createContext({})

export default DefaultSettingsSetupContext
